import { decrypt } from '@/public/utils'
import Router from '@/layout/router'

const MASK_KEY = 'Mask'
const VIRTUAL_KEY = 'Virtual'

const isMask = (value, fieldName) => value && String(fieldName).endsWith(MASK_KEY)
const isVirtual = (value, fieldName) => value && String(fieldName).endsWith(VIRTUAL_KEY)

export function decryptPlugin () {
  function DECRYPT_checkMaskInRow (val, fieldName) {
    // 字段如果被批量解密，mask判断有误，需判断字段是否已经批量解密
    const mask = isMask(val, fieldName)
    return mask || isVirtual(val, fieldName)
  }
  function DECRYPT_beforeDecryptAction ({ value, fieldName, beforeDecrypt }) {
    const mask = isMask(value, fieldName)
    const virtual = isVirtual(value, fieldName)
    // 2023-01-05 当用户知道字段可能存在加密或者虚拟号额情况下使用。需绕过func方法时，在解密字段前使用
    if (beforeDecrypt && typeof beforeDecrypt === 'function' && beforeDecrypt({ value, fieldName, mask, virtual }) === true) {
      return false
    }
    return true
  }
  async function DECRYPT_handleDecryptAction ({
    value,
    beforeDecrypt,
    afterDecrypt,
    moduleCode,
    dataId = '0',
    fieldName,
    fieldContent,
    fieldNameStr = ''
  }) {
    if (!DECRYPT_checkMaskInRow(value, fieldName)) {
      return null
    }
    const valdite = await DECRYPT_beforeDecryptAction({ value, fieldName, beforeDecrypt })
    if (!valdite) {
      return null
    }
    const mask = isMask(value, fieldName)
    const virtual = isVirtual(value, fieldName)
    if (!mask && !virtual) {
      return null
    }

    const res = await decrypt({
      dataId,
      moduleCode,
      fieldName,
      fieldContent,
      fieldNameStr,
      buttonName: Router.currentRoute.meta.title || '',
      autoFocus: false // 2022-10-28 关闭解密提示框时，不自动聚焦回canvas元素（否则部分页面会抖一下）
    }, mask ? MASK_KEY.toLowerCase() : VIRTUAL_KEY.toLowerCase())
    // 金额、数据字典等解密后也需要 formatter
    if (afterDecrypt && typeof afterDecrypt === 'function') {
      const val = afterDecrypt({ preValue: value, currentValue: res, fieldName, mask, virtual })
      return val || null
    }
    return res || null
  }
  return {
    DECRYPT_beforeDecryptAction,
    DECRYPT_handleDecryptAction,
    DECRYPT_checkMaskInRow
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-input-money/decrypt-plugin.js